if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.enableSwiper = this.getAttribute('data-enable-swiper') == 'true';
        if (this.enableSwiper) {
          this.createSwiper();
        }
      }

      hide() {
        super.hide();
        for (const element of this.querySelectorAll('.slide--scale')) {
          if (element) element.classList.remove('slide--scale');
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        if (!this.enableSwiper) {
          activeMedia.scrollIntoView();
          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        } else {
          const slide = activeMedia.closest('.swiper-slide');
          if (slide) {
            const slides = this.mySwiper.slides.filter((v) => v.clientWidth > 0 && v.innerHTML && (v.innerHTML.trim() != ''));
            const index = slides.findIndex((v) => v === slide);
            console.log(slides, slide, index)
            this.mySwiper.slideTo(index, 0);
          }
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      createSwiper() {
        this.mySwiper = new Swiper(this.querySelector('.swiper'), {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 8,
          centeredSlides: true,
          noSwiping: true,
          noSwipingClass: 'slide--scale',
          observer: true,
          resizeObserver: true,
          navigation: {
            nextEl: this.querySelector(`.swiper-btn-next`),
            prevEl: this.querySelector(`.swiper-btn-prev`),
          },
          pagination: {
            el: this.querySelector('.swiper-custom-pagination'),
            type: 'fraction',
          },
        });
        this.addEventListener('click', (e) => {
          const target = e.target;
          if (target.tagName === 'IMG') {
            const slide = target.closest('.swiper-slide');
            for (const element of this.querySelectorAll('.slide--scale')) {
              if (element != slide) element.classList.remove('slide--scale');
            }
            slide?.classList.toggle('slide--scale');
            // Scroll to center
            slide.scrollLeft = (slide.scrollWidth - slide.clientWidth) / 2;
            slide.scrollTop = (slide.scrollHeight - slide.clientHeight) / 2;
          }
        });
      }
    }
  );
}
